module.exports = __webpack_public_path__ + "static/media/okay.cf281ece.png";